import { TFunction } from 'i18next';
import moment from 'moment';

import Nullable from 'packages/kakapo-ui-services/types/Nullable';

type Moment = moment.Moment;

const dateDayStringFormat = 'YYYY-MM-DD';

class DateService {
	static today = moment(new Date()).startOf('day').toDate();

	static fromDateDayString(dateDayString: string): Date {
		return moment(dateDayString, dateDayStringFormat).toDate();
	}

	static toDateDayString(date: Date): string {
		return moment(date).format(dateDayStringFormat);
	}

	static isBeforeToday = (d: Moment) => d.isBefore(moment(Date.now()).startOf('day'));

	static daysAgo = (date: Date, from: Date, t: (input: string) => string): string => {
		const fromDate = moment(from);
		const days = fromDate.startOf('day').diff(moment(date), 'days');
		if (days === 0) {
			return t('common.today');
		}
		return moment(date).from(fromDate.startOf('day'));
	};

	static isDateEqual = (lhs: Date, rhs: Date): boolean => lhs.getTime() === rhs.getTime();

	static getStartedOnLabelFromDate = (date: Date, t: TFunction) => {
		const momentDate = moment(date);
		if (momentDate.isSame(DateService.today, 'day')) {
			return t('common.startedToday');
		}
		if (momentDate.isBefore(DateService.today)) {
			return t('common.startedOn', { date: momentDate.format('LL') });
		}
		return t('common.willStartOn', { date: momentDate.format('LL') });
	};

	static getEndedOnLabelFromDate = (date: Nullable<Date>, t: TFunction) => {
		if (date === null) {
			return t('common.settings.jobs.jobPositions.noEndDate');
		}

		const momentDate = moment(date);
		if (momentDate.isSame(DateService.today, 'day')) {
			return t('common.endedToday');
		}
		if (momentDate.isBefore(DateService.today)) {
			return t('common.endedOn', { date: momentDate.format('LL') });
		}
		return t('common.willEndOn', { date: momentDate.format('LL') });
	};
}

export default DateService;
